import { Dictionary } from 'src/app/core/model/dictionary';
// Generated by https://quicktype.io

export interface Member
{
  id: number;
  version: number;
  name: Name;
  givenName: string;
  familyName: string;
  employer: string;
  dateOfBirth: Date;
  age?: number;
  contact: Contact;
  gender: Gender;
  ethnicGroup: string;
  maritalStatus: string;
  race: string;
  religiousAffiliation: string;
  spokenLanguage: string;
  preferredLanguage: string;
  address: Address;
  mrn: string;
  starred: boolean;
  memberUpdate: Member;
  communityOrganization: any;
  notificationType: string;
}

export interface MemberEligibility
{
  eligible: boolean;
  medicaidMissing: boolean;
  eligibilityStartDate: string;
  eligibilityEndDate: string;
  disenrollDate: string;
  lastChecked: string;
  patientName: string;
}

export class Address
{
  public id: number;
  public version: number;
  public city: string;
  public county: string;
  public poBox: string;
  public streetLine: string;
  public streetLineAdditional: string;
  public country: Dictionary;
  public postalCode: string;
  public state: Dictionary;
  public longitude: number;
  public latitude: number;
  public addressType: Dictionary;
}

export interface Contact
{
  email: string;
  homePhoneNumber: string;
  cellPhoneNumber: string;
  preferredVideoProvider: any;
}

export class Insurance
{
  public id: number;
  public version: number;
  public insurer: string;
  public plan: string;
  public groupId: string;
  public insuranceMemberId: string;
  public memberType: string;
  public policyHolder: string;
  public insuredFamilyName: string;
  public insuredGivenName: string;
  public employer: string;
  public insurerUrl: string;
  public businessPhoneNumber: string;
  public card: any;
  public cardDocumentUrl: string = null;
  public cardDocumentName: string = null;
  public cardDocumentId: number = null;
  public cardDocumentMimeType: string = null;
  public deleteCard = false;
  public startDate: any;
  public endDate: any;
  public insuranceExternalId: string;
}

export class Insurer
{
  public id: number;
  public name: string;
  public active: boolean;
}

export interface Name
{
  familyName: string;
  givenName: string;
  middleName: string;
  prefix: string;
  suffix: string;
  preferredName: string;
  professionalSuffix: string;
  fullName: string;
}

export interface Gender
{
  displayName: string;
}
export interface LinkedMember
{
  memberId: number;
  familyName: string;
  givenName: string;
  fullName: string;
  relationship: Relationship;
  consentAllowed: boolean;
}

export interface Relationship
{
  id: number;
  displayName: string;
  code: string;
  icon: null;
  version: number;
  codeSystem: string;
}

export interface MemberLink
{
  memberId: number;
  linkMemberId: number;
  relationshipId: number;
}
